module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.type
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.$t('encyclopedia.' + _vm.type),
      "level": 2,
      "font": "astonished",
      "color": "yellow"
    }
  }), _vm._v(" "), _c('search-input', {
    on: {
      "typing": _vm.getData
    }
  }), _vm._v(" "), _c('list', {
    attrs: {
      "scroll": false,
      "items": _vm.items,
      "link": _vm.routeName,
      "fields": _vm.fields,
      "type": "min"
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac098cfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/Search.vue
// module id = 279
// module chunks = 0